import { useCallback } from 'react';
import { FLOW_KEY } from '../../../../../constants/constants';
import { Edge, Node, useReactFlow } from '@xyflow/react';

export const useRestoreFlow = (setNodes: (value: React.SetStateAction<Node[]>) => void, setEdges: (value: React.SetStateAction<Edge[]>) => void) => {
    const { setViewport } = useReactFlow();

    const onRestore = useCallback(() => {
        const restoreFlow = async () => {
            const flow = JSON.parse(localStorage.getItem(FLOW_KEY) || '{}');

            if (flow) {
                const { x = 0, y = 0, zoom = 1 } = flow.viewport || {};
                const restoredNodes = flow.nodes.map((node: Node) => ({
                    ...node,
                    style: node.data?.style || {}, // Vraćanje stilova iz data objekta
                }));
                setNodes(restoredNodes);
                setEdges(flow.edges || []);
                setViewport({ x, y, zoom });
            }
        };

        restoreFlow();
    }, [setNodes, setEdges, setViewport]);

    return { onRestore };
};
